import { create } from "zustand";
import { v4 as uuidv4 } from "uuid";
import { filterSerializable } from "@/utils/utils";

export enum IFRAME_STATE {
  LOADING = "LOADING",
  SHOWING = "SHOWING",
  HIDDEN = "HIDDEN",
}

export interface IFrameMessage {
  id: string;
  type: string;
  payload: any;
}

interface IframeStore {
  pendingSelectionCodebaseId: string | null;
  setPendingSelectionCodebaseId: (codebaseId: string | null) => void;

  iframeMessagingPorts: { [storyboardId: string]: MessagePort };
  setIframeMessagingPorts: (iframeMessagingPorts: {
    [storyboardId: string]: MessagePort;
  }) => void;
  setPortForStoryboardId: (storyboardId: string, port: MessagePort) => void;

  // Actions
  sendMessageToIFrame: (
    message: Partial<IFrameMessage>,
    storyboardId?: string
  ) => void;
}

export const useIframeStore = create<IframeStore>((set, get) => ({
  pendingSelectionCodebaseId: null,
  setPendingSelectionCodebaseId: (codebaseId: string | null) => {
    set({ pendingSelectionCodebaseId: codebaseId });
  },

  iframeMessagingPorts: {},
  setIframeMessagingPorts: (iframeMessagingPorts: {
    [storyboardId: string]: MessagePort;
  }) => {
    set({ iframeMessagingPorts });
  },

  setPortForStoryboardId: (storyboardId: string, port: MessagePort) => {
    set((state) => ({
      iframeMessagingPorts: {
        ...state.iframeMessagingPorts,
        [storyboardId]: port,
      },
    }));
  },
  sendMessageToIFrame: ({ id, type, payload }, storyboardId) => {
    const newMessage = {
      id: id || uuidv4(),
      type: type!,
      payload: payload,
      storyboardId: storyboardId,
    };

    const { iframeMessagingPorts } = get();

    Object.keys(iframeMessagingPorts).forEach((sId) => {
      if (storyboardId && sId != storyboardId) {
        return;
      }

      const port = iframeMessagingPorts[sId];
      port.postMessage(filterSerializable(newMessage));
    });
  },
}));
